import { useEffect, useState } from "react";
import { adminGetSiteCopy, adminPutSiteCopy } from "@/lib/api";
import { Check } from "lucide-react";

const LABELS = {
  hero_headline: "Hero headline", hero_subhead: "Hero subhead", proof_band: "Proof band",
  commitment_1_title: "Commitment 1 title", commitment_1_body: "Commitment 1 body",
  commitment_2_title: "Commitment 2 title", commitment_2_body: "Commitment 2 body",
  commitment_3_title: "Commitment 3 title", commitment_3_body: "Commitment 3 body",
  packet_title: "Operating Room title", packet_body: "Operating Room teaser",
};
const ORDER = Object.keys(LABELS);

export default function AdminSiteCopy() {
  const [items, setItems] = useState({});
  const [saved, setSaved] = useState("");
  const load = () => adminGetSiteCopy().then((rows) => {
    const map = {}; rows.forEach((r) => (map[r.key] = r.value)); setItems(map);
  }).catch(() => {});
  useEffect(() => { load(); }, []);

  const save = async (key) => {
    await adminPutSiteCopy({ key, value: items[key] || "" });
    setSaved(key); setTimeout(() => setSaved(""), 2000);
  };

  return (
    <div data-testid="admin-site-copy">
      <p className="cv-kicker">Site copy</p>
      <h1 className="cv-display text-3xl mt-4">Edit the words on the live site.</h1>
      <div className="mt-8 space-y-6 max-w-2xl">
        {ORDER.map((key) => (
          <div key={key} data-testid={`admin-copy-field-${key}`}>
            <span className="cv-sans uppercase tracking-[0.12em] text-[0.68rem] text-[#1F1B16]/70">{LABELS[key]}</span>
            <textarea
              data-testid={`admin-copy-input-${key}`}
              rows={key.includes("body") || key.includes("subhead") || key.includes("band") ? 3 : 2}
              className="cv-input mt-1.5 resize-none"
              value={items[key] || ""}
              onChange={(e) => setItems({ ...items, [key]: e.target.value })}
            />
            <div className="flex items-center gap-3 mt-2">
              <button data-testid={`admin-copy-save-${key}`} className="cv-btn-secondary" onClick={() => save(key)}>Save</button>
              {saved === key && <span className="cv-body text-xs text-[#515E4F] inline-flex items-center gap-1"><Check size={13} /> Saved to live site</span>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
